module.exports = __webpack_public_path__ + "img/1.1aaa5497.png";